import FeedbackCheckBoxVue from './FeedbackCheckBox.vue';
<script lang="ts" setup>
import { computed } from 'vue';
import FeedbackSelectOption from './FeedbackSelectOption.vue';
import FeedbackFreeText from './FeedbackFreeText.vue';
import FeedbackCheckBox from './FeedbackCheckBox.vue';
import { useFeedback } from '../composable/useFeedback';

const { questionActive: question } = useFeedback();

const componentRender = computed(() => {
  return question.value?.type === 'CHECKBOX'
    ? FeedbackCheckBox
    : question.value?.type === 'FILL_TEXT'
    ? FeedbackFreeText
    : FeedbackSelectOption;
});
</script>

<template>
  <component :is="componentRender" :question="question" />
</template>
